module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/9887cc8e9a4ae5c4c0dde2e5abb925dd.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_plus.svg
// module id = 1YY9
// module chunks = 1